export default [
  ...applyRules(['guest'], [
    {
      path: '',
      component: require('#Components/frontend/Wrapper').default,
      children:
      [
        { path: '/', name: 'index', component: require('#Components/frontend/page/Welcome').default },
        { path: '/401', name: 'error401', component: require('#Components/frontend/error/Error401').default },
        { path: '/404', name: 'error404', component: require('#Components/frontend/error/Error404').default },
      ]
    }
  ]),
  ...applyRules(['auth'], [
    {
      path: '/app/',
      component: require('#Components/admin/Wrapper').default,
      children:
      [
        { path: '', name: 'app.index', component: require('#Components/admin/modules/Dashboard').default },
        { path: 'setup', name: 'app.setup', component: require('#Components/admin/modules/Setup').default },
      ]
    },
  ]),
  { path: '*', redirect: { name: 'error404' } }
]

function applyRules(rules, routes) {
  for (let i in routes) {
    routes[i].meta = routes[i].meta || {}

    if (!routes[i].meta.rules) {
      routes[i].meta.rules = []
    }
    routes[i].meta.rules.unshift(...rules)

    if (routes[i].children) {
      routes[i].children = applyRules(rules, routes[i].children)
    }
  }

  return routes
}
